import { connectionCreatorApi } from "api/TenantSlug/ConnectionCreator/api.ts";

export function composeGetScenarioQueryOptions(scenarioId: string) {
    return {
        queryKey: ["getScenario", scenarioId],
        queryFn: () => connectionCreatorApi.getScenario(scenarioId),
    };
}

export function getScenarioQueryOptions(scenarioId: string) {
    return {
        ...composeGetScenarioQueryOptions(scenarioId),
        suspense: true,
    };
}
